var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerPractitioner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_banner_prac)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4172 10.5852L21.7803 8.94859C21.3918 8.5601 21.0735 7.79238 21.0735 7.24181V4.92728C21.0735 3.82626 20.1741 2.92682 19.0733 2.92623H16.7579C16.2079 2.92623 15.4393 2.60729 15.0508 2.2191L13.4142 0.582515C12.6366 -0.19511 11.3634 -0.19511 10.5857 0.582515L8.94915 2.22027C8.5603 2.60876 7.79082 2.92682 7.24207 2.92682H4.92754C3.82799 2.92682 2.92737 3.82626 2.92737 4.92728V7.24187C2.92737 7.79027 2.60908 8.56039 2.22053 8.94865L0.583658 10.5852C-0.194553 11.3629 -0.194553 12.6361 0.583658 13.4149L2.22053 15.0515C2.60931 15.44 2.92737 16.2098 2.92737 16.7583V19.0729C2.92737 20.1727 3.82799 21.0733 4.92754 21.0733H7.24213C7.79206 21.0733 8.56066 21.3916 8.94921 21.7799L10.5858 23.4171C11.3634 24.1941 12.6366 24.1941 13.4143 23.4171L15.0508 21.7799C15.4397 21.3914 16.208 21.0733 16.7579 21.0733H19.0734C20.1741 21.0733 21.0736 20.1727 21.0736 19.0729V16.7583C21.0736 16.2075 21.3921 15.4398 21.7804 15.0515L23.4173 13.4149C24.1943 12.6361 24.1943 11.3628 23.4172 10.5852ZM10.4123 16.4999L5.99949 12.0865L7.41376 10.6725L10.4127 13.6714L16.586 7.49957L17.9999 8.91355L10.4123 16.4999Z",
    fill: "#112314"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_banner_prac"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerPractitioner);
export default __webpack_public_path__ + "static/media/banner_practitioner.bf13e2430ee205d163715959276f9923.svg";
export { ForwardRef as ReactComponent };